import React, {useMemo} from 'react'
import { useTable, usePagination, useSortBy, useFilters } from 'react-table'
import FeatureFilter from './FeatureFilter';

export default function FeatureTable({ columns, data }) {
  const categories = useMemo(() => Object.keys(data.reduce((prev, curr) => ({...prev, [curr.Category]: true}), {})), [data]);
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setFilter,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, sortBy:[{id: "Category", desc: true}, {id: "Features", desc: true}] },
    },
    useFilters,
    useSortBy,
    usePagination
  )

  // Render the UI for your table
  return (
    <>
      <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 mb-5 text-white font-bold tracking-wider uppercase text-md">Features</h2>
      <div className="w-full overflow-x-scroll">
        <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative" {...getTableProps()}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr className="text-left" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th className="sticky top-0 border-b border-b-4 border-gray-200 px-6 py-2 font-bold tracking-wider uppercase text-md" {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? <i className="fas fa-chevron-down ml-1"></i>
                        : <i className="fas fa-chevron-up ml-1"></i>
                      : ''}
                  </span>
                </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return (
                    <td className="border-dashed border-t border-gray-200" {...cell.getCellProps()}>
                      <span className="text-gray-800 px-6 py-2 flex items-center">
                        {cell.render('Cell')}
                      </span>
                    </td>
                  )})}
                </tr>
            )})}
          </tbody>
        </table>
      </div>
      <div className="pagination my-2 flex items-baseline">
        <div>
          <button onClick={() => previousPage()} disabled={!canPreviousPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
            {'<'}
          </button>{' '}
          <button onClick={() => nextPage()} disabled={!canNextPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
            {'>'}
          </button>{' '}
          <span className="text-gray-800 px-6 py-1">
            Page{' '}
            <strong className="text-gray-800 px-6 py-1">
              {pageIndex + 1} of {pageOptions.length}
            </strong>{' '}
          </span>
        </div>
        <FeatureFilter categories={categories} setFilter={setFilter} />
      </div>
    </>
  )
}
